module.exports = __webpack_public_path__ + "static/media/808ColumnLabel--6.fb097671.svg";